<template>
<div>
    <v-btn small color="success" outlined class="font-weight-black" @click.stop="displayDialog">
        <v-icon left small>fas fa-rss</v-icon>
        Sincronizar Softnet
    </v-btn>
    <v-dialog v-model='displaySoftnet' fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
        <create-document 
        :sales_note_id='sales_note'
        @close="displaySoftnet=false" />
    </v-dialog>
</div>
</template>
<script>
import CreateDocument from '@/components/softnet/CreateDocument.vue'
import { integer } from 'vee-validate/dist/rules'
import notifications from '../../utils/notifications'
export default {
    components: {
        CreateDocument
    },
    props: {
        sales_note: {
            required: true
        }
    },
    data() {
        return {
            displaySoftnet: false,
        }
    },
    methods: {
        displayDialog() {
            if(this.sales_note) this.displaySoftnet = true
            else notifications.showError('Por favor seleccione una nota de venta')
        },
    }
}
</script>